import { render, staticRenderFns } from "./AuthButton.vue?vue&type=template&id=24165aeb&scoped=true&"
import script from "./AuthButton.vue?vue&type=script&lang=js&"
export * from "./AuthButton.vue?vue&type=script&lang=js&"
import style0 from "./AuthButton.vue?vue&type=style&index=0&id=24165aeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24165aeb",
  null
  
)

export default component.exports